export class CriteriaActions {
    static DROPDOWN = 'dropdown';
    static MULTIDROPDOWN = 'multidropdown';
    static UPLOAD = 'upload';
    static TEXT = 'text';
    static TEXT_TAG = 'text_tag';
    static STRING = 'string';
    static SWITCH_UNIX = 'switch_unix';
    static SWITCH_TAG = 'switch_tag';
}


// WEBPACK FOOTER //
// ./src/helpers/forms/form-criteria-actions.js